/* ============ PUPLYO shared JS (vanilla, theme-safe) ============ */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');

  var moneyFormat = (window.PuplyoSettings && window.PuplyoSettings.moneyFormat) || '${{amount}}';
  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
  }
  window.PuplyoMoney = money;

  /* ---- reveal on scroll ---- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.pup-reveal:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- rotating announcement ---- */
  function initAnnouncements(root) {
    (root || document).querySelectorAll('[data-pup-announce]').forEach(function (bar) {
      var msgs = bar.querySelectorAll('[data-pup-msg]');
      if (msgs.length < 2 || bar.dataset.pupInit) return;
      bar.dataset.pupInit = '1';
      var i = 0;
      setInterval(function () {
        msgs[i].style.display = 'none';
        i = (i + 1) % msgs.length;
        msgs[i].style.display = '';
        msgs[i].style.animation = 'none'; void msgs[i].offsetWidth; msgs[i].style.animation = '';
      }, 3600);
    });
  }

  /* ---- countdown (persisted) ---- */
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-pup-countdown]').forEach(function (el) {
      if (el.dataset.pupInit) return; el.dataset.pupInit = '1';
      var key = 'puplyo_deal_end_' + (el.dataset.pupCountdown || 'x');
      var dur = parseFloat(el.dataset.hours || '4') * 3600 * 1000;
      var offset = dur > 3600000 ? 769000 : 0;
      var end = parseInt(localStorage.getItem(key) || '0', 10);
      if (!end || end < Date.now()) { end = Date.now() + dur - offset; localStorage.setItem(key, String(end)); }
      var hEl = el.querySelector('[data-h]'), mEl = el.querySelector('[data-m]'), sEl = el.querySelector('[data-s]');
      function tick() {
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (hEl) hEl.textContent = String(Math.floor(left / 3600)).padStart(2, '0');
        if (mEl) mEl.textContent = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
        if (sEl) sEl.textContent = String(left % 60).padStart(2, '0');
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---- carousel arrows ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pup-scroll]');
    if (!btn) return;
    var target = document.getElementById(btn.dataset.target);
    if (target) target.scrollBy({ left: (btn.dataset.pupScroll === 'prev' ? -1 : 1) * 340, behavior: 'smooth' });
  });

  /* ---- drawers (mobile menu / cart / filters) ---- */
  function setDrawer(id, open) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.toggle('open', open);
    d.setAttribute('aria-hidden', open ? 'false' : 'true');
    var ov = document.querySelector('[data-pup-overlay="' + id + '"]');
    if (ov) ov.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  window.PuplyoDrawer = setDrawer;
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-pup-open]');
    if (op) { e.preventDefault(); setDrawer(op.dataset.pupOpen, true); return; }
    var cl = e.target.closest('[data-pup-close]');
    if (cl) { e.preventDefault(); setDrawer(cl.dataset.pupClose, false); return; }
    var ov = e.target.closest('.pup-overlay[data-pup-overlay]');
    if (ov && e.target === ov) setDrawer(ov.dataset.pupOverlay, false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.pup-drawer.open,[data-pup-modal].open').forEach(function (d) { setDrawer(d.id, false); });
  });

  /* ---- sticky header solid state ---- */
  function initHeader() {
    var hd = document.querySelector('[data-pup-header]');
    if (!hd) return;
    var f = function () { hd.classList.toggle('solid', window.scrollY > 8); };
    f(); window.addEventListener('scroll', f, { passive: true });
  }

  /* =================== CART =================== */
  var Cart = {
    state: null,
    fetch: function () {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { Cart.state = c; Cart.render(); return c; });
    },
    add: function (items) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      }).then(function () { return Cart.fetch(); }).then(function () { Cart.open(); });
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (c) { Cart.state = c; Cart.render(); });
    },
    open: function () { setDrawer('PuplyoCartDrawer', true); },
    render: function () {
      var c = Cart.state; if (!c) return;
      document.querySelectorAll('[data-pup-cart-count]').forEach(function (el) {
        el.textContent = c.item_count; el.style.display = c.item_count > 0 ? '' : 'none';
      });
      var drawer = document.getElementById('PuplyoCartDrawer');
      if (!drawer) return;
      var cfg = window.PuplyoSettings || {};
      var giftT = (cfg.giftThreshold || 50) * 100, shipT = (cfg.shipThreshold || 35) * 100;
      var sub = c.total_price;
      var msgEl = drawer.querySelector('[data-pup-milestone-msg]');
      if (msgEl) {
        if (sub < shipT) msgEl.innerHTML = 'Add <b>' + money(shipT - sub) + '</b> to unlock <b>free shipping</b>';
        else msgEl.innerHTML = 'You unlocked <b>free shipping</b>! 🎉';
      }
      var bar = drawer.querySelector('[data-pup-progress]');
      if (bar) bar.style.width = Math.min(100, (sub / shipT) * 100) + '%';
      var msShip = drawer.querySelector('[data-pup-ms-ship]');
      if (msShip) msShip.classList.toggle('done', sub >= shipT);
      var subEl = drawer.querySelector('[data-pup-subtotal]');
      if (subEl) subEl.textContent = money(sub);
      var shipNote = drawer.querySelector('[data-pup-ship-note]');
      if (shipNote) shipNote.textContent = sub >= shipT ? 'Free shipping applied' : 'Free shipping at ' + money(shipT);
      var emptyEl = drawer.querySelector('[data-pup-cart-empty]'), fullEl = drawer.querySelector('[data-pup-cart-full]'), footEl = drawer.querySelector('[data-pup-cart-foot]');
      if (emptyEl) emptyEl.style.display = c.item_count ? 'none' : '';
      if (fullEl) fullEl.style.display = c.item_count ? '' : 'none';
      if (footEl) footEl.style.display = c.item_count ? '' : 'none';
      var list = drawer.querySelector('[data-pup-cart-items]');
      if (list) {
        list.innerHTML = c.items.map(function (it) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') : '';
          return '<div class="pup-ci" data-key="' + it.key + '">' +
            '<div class="pup-ci-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="pup-ci-body"><div class="pup-ci-top"><span class="pup-ci-title">' + it.product_title + '</span>' +
            '<button type="button" class="pup-ci-rm" data-pup-remove="' + it.key + '" aria-label="Remove">&#10005;</button></div>' +
            '<div class="pup-ci-meta">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') + '</div>' +
            '<div class="pup-ci-row"><div class="pup-ci-qty">' +
            '<button type="button" data-pup-qty="-1" data-key="' + it.key + '" aria-label="Decrease">&#8722;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-pup-qty="1" data-key="' + it.key + '" aria-label="Increase">+</button></div>' +
            '<span class="pup-ci-price pup-fred">' + money(it.final_line_price) + '</span></div></div></div>';
        }).join('');
      }
      drawer.querySelectorAll('[data-pup-upsell-variant]').forEach(function (u) {
        var vid = parseInt(u.dataset.pupUpsellVariant, 10);
        var inCart = c.items.some(function (it) { return it.variant_id === vid; });
        u.style.display = inCart ? 'none' : '';
      });
    }
  };
  window.PuplyoCart = Cart;

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-pup-remove]');
    if (rm) { Cart.change(rm.dataset.pupRemove, 0); return; }
    var qb = e.target.closest('[data-pup-qty]');
    if (qb) {
      var item = (Cart.state.items || []).find(function (i) { return i.key === qb.dataset.key; });
      if (item) Cart.change(item.key, Math.max(0, item.quantity + parseInt(qb.dataset.pupQty, 10)));
      return;
    }
    var up = e.target.closest('[data-pup-add-variant]');
    if (up) {
      up.disabled = true;
      Cart.add([{ id: parseInt(up.dataset.pupAddVariant, 10), quantity: 1 }])
        .catch(function (err) { alert((err && err.description) || 'Could not add to cart'); })
        .finally(function () { up.disabled = false; });
    }
  });

  /* ---- quick add buttons (product cards) ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-pup-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var fd = new FormData(form);
    var items = [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) }];
    var extra = form.dataset.pupExtraVariant;
    if (extra) items.push({ id: parseInt(extra, 10), quantity: 1 });
    if (btn) { btn.dataset.orig = btn.innerHTML; btn.disabled = true; }
    Cart.add(items).then(function () {
      if (btn) { btn.innerHTML = 'Added ✓'; setTimeout(function () { btn.innerHTML = btn.dataset.orig; btn.disabled = false; }, 1300); }
    }).catch(function (err) {
      if (btn) { btn.innerHTML = btn.dataset.orig; btn.disabled = false; }
      alert((err && err.description) || 'Could not add to cart');
    });
  });

  /* ---- video modal ---- */
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-pup-video]');
    if (!v) return;
    e.preventDefault();
    var modal = document.getElementById('PuplyoVideoModal');
    if (!modal) return;
    var url = v.dataset.pupVideo, poster = v.dataset.poster || '', name = v.dataset.name || '', headline = v.dataset.headline || '';
    var box = modal.querySelector('[data-pup-video-box]');
    var media = '';
    if (url && /youtube\.com|youtu\.be/.test(url)) {
      var idm = url.match(/(?:v=|youtu\.be\/|shorts\/)([\w-]{6,})/);
      media = idm ? '<iframe src="https://www.youtube.com/embed/' + idm[1] + '?autoplay=1&playsinline=1&modestbranding=1&rel=0&iv_load_policy=3&origin=' + encodeURIComponent(location.origin) + '" referrerpolicy="strict-origin-when-cross-origin" allow="autoplay; fullscreen; encrypted-media" allowfullscreen title="' + name + '"></iframe>' : '';
    } else if (url && /vimeo\.com/.test(url)) {
      var vm = url.match(/vimeo\.com\/(\d+)/);
      media = vm ? '<iframe src="https://player.vimeo.com/video/' + vm[1] + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen title="' + name + '"></iframe>' : '';
    } else if (url) {
      media = '<video src="' + url + '" autoplay playsinline controls ' + (poster ? 'poster="' + poster + '"' : '') + '></video>';
    } else if (poster) {
      media = '<img src="' + poster + '" alt="">';
    }
    box.innerHTML = media +
      '<div class="pup-vm-cap"><div class="pup-stars" aria-hidden="true">★★★★★</div>' +
      (headline ? '<div class="pup-fred pup-vm-h">“' + headline + '”</div>' : '') +
      (name ? '<div class="pup-vm-n">' + name + '</div>' : '') + '</div>';
    setDrawer('PuplyoVideoModal', true);
  });
  document.addEventListener('click', function (e) {
    var modal = document.getElementById('PuplyoVideoModal');
    if (modal && modal.classList.contains('open') && (e.target === modal)) {
      modal.querySelector('[data-pup-video-box]').innerHTML = '';
      setDrawer('PuplyoVideoModal', false);
    }
    var c = e.target.closest('[data-pup-close="PuplyoVideoModal"]');
    if (c && modal) modal.querySelector('[data-pup-video-box]').innerHTML = '';
  });

  /* ---- product gallery: swipe the main image on touch (mobile) ---- */
  function initGallerySwipe(root) {
    (root || document).querySelectorAll('.pup-pm-main:not([data-pup-swipe])').forEach(function (main) {
      main.dataset.pupSwipe = '1';
      var x0 = null, y0 = null;
      main.addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var gallery = main.closest('.pup-pm-gallery'); if (!gallery) return;
        var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pup-thumb]'));
        if (thumbs.length < 2) return;
        var idx = thumbs.findIndex(function (th) { return th.classList.contains('active'); });
        if (idx < 0) idx = 0;
        var next = dx < 0 ? idx + 1 : idx - 1;
        if (next < 0) next = thumbs.length - 1;
        if (next >= thumbs.length) next = 0;
        thumbs[next].click();
      }, { passive: true });
    });
  }

  /* ---- boot ---- */
  function boot() {
    initReveals(); initAnnouncements(); initCountdowns(); initHeader(); initGallerySwipe();
    Cart.fetch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target); initAnnouncements(e.target); initCountdowns(e.target); initHeader(); initGallerySwipe(e.target);
  });
})();
